import {get} from "lodash"
import BaseService from "./Base"

class ScrubReportsService extends BaseService {
    async list(params) {
        const response = await this.post(`/v1/scrub-reports/list`, params)
        return get(response, "data", [])
    }
}

export default ScrubReportsService
